import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "./useRoutes";
export const getUniqueValuesByKey = (list, key) => {
    console.log("Get unique ", list);
    const uniqueValues = new Set();
    list.forEach((template) => {
        let values = key(template);
        if (!Array.isArray(values)) {
            values = [values];
        }
        values.forEach((value) => {
            if (value !== "") {
                uniqueValues.add(value);
            }
        });
    });
    return Array.from(uniqueValues).sort((a, b) => a.toString().localeCompare(b.toString(), undefined, {
        numeric: true,
        sensitivity: "base",
    }));
};
const isChecked = (key, predef, value) => {
    if (!predef) {
        return false;
    }
    // Ensure value is a string
    const stringValue = value.toString();
    const values = predef[key];
    // Return false if the key is not in predef or the value is empty
    if (!values) {
        return false;
    }
    // Check for both string and array cases
    if (typeof values === "string" || values instanceof String) {
        return stringValue === values;
    }
    else if (Array.isArray(values)) {
        console.log("Check if value", values, stringValue);
        return values.includes(stringValue);
    }
    // If values is neither a string nor an array, return false
    return false;
};
export default (templateList, options) => {
    const [filters, setFilters] = useState([]);
    const [t] = useTranslation();
    const history = useHistory();
    const location = useLocation();
    console.log("Use tmeplate filters", templateList);
    const toggleFilterOption = (type, value) => {
        const filterTypes = filters.map((filterType) => {
            if (filterType.type === type) {
                const options = filterType.options.map((option) => {
                    if (option.value === value) {
                        return Object.assign(Object.assign({}, option), { checked: !option.checked });
                    }
                    return option;
                });
                return Object.assign(Object.assign({}, filterType), { options: options });
            }
            return filterType;
        });
        let url = "";
        for (const filter of filterTypes) {
            for (const option of filter.options) {
                if (option.checked) {
                    if (url) {
                        url += "&";
                    }
                    url += filter.type + "[]=" + encodeURIComponent(option.value);
                }
            }
        }
        history.replace(location.pathname + "?" + url);
    };
    useEffect(() => {
        if (!templateList) {
            return;
        }
        const filterList = [];
        if (options.filters.indexOf("formats") >= 0) {
            const formatOptions = getUniqueValuesByKey(templateList.templates, (t) => t.product.formatSize).map((option) => {
                const checked = isChecked("formats", options === null || options === void 0 ? void 0 : options.predef, option);
                return {
                    name: option,
                    value: option,
                    checked: checked,
                };
            });
            if (formatOptions.length > 1) {
                filterList.push({
                    title: t("Format"),
                    type: "formats",
                    key: "formats",
                    filterFunction: (template, value) => {
                        return template.product.formatSize == value;
                    },
                    options: formatOptions,
                });
            }
        }
        if (options.filters.indexOf("texts") >= 0) {
            const yesChecked = isChecked("texts", options === null || options === void 0 ? void 0 : options.predef, "1");
            const noChecked = isChecked("texts", options === null || options === void 0 ? void 0 : options.predef, "0");
            filterList.push({
                title: t("With text"),
                type: "texts",
                key: "texts",
                filterFunction: (template, value) => {
                    console.log("The filter value is", value);
                    return template.hasUserText == value;
                },
                options: [
                    {
                        name: t("Yes"),
                        value: "1",
                        checked: yesChecked,
                    },
                    {
                        name: t("No"),
                        value: "0",
                        checked: noChecked,
                    },
                ],
            });
        }
        if (options.filters.indexOf("images") >= 0) {
            const numImagesOptions = getUniqueValuesByKey(templateList.templates, (t) => t.numUserImages)
                .sort((a, b) => a - b)
                .map((images) => {
                const checked = isChecked("images", options === null || options === void 0 ? void 0 : options.predef, images);
                return {
                    name: images.toString(),
                    value: images,
                    checked: checked,
                };
            });
            if (numImagesOptions.length > 1) {
                filterList.push({
                    title: t("Images") || '',
                    type: "images",
                    key: "images",
                    filterFunction: (template, value) => {
                        return template.numUserImages == value;
                    },
                    options: numImagesOptions,
                });
            }
        }
        if (options.filters.indexOf("pages")) {
            const pagesOptions = getUniqueValuesByKey(templateList.templates, (t) => t.numUserParts).map((pages) => {
                const checked = isChecked("pages", options === null || options === void 0 ? void 0 : options.predef, pages);
                return {
                    name: pages,
                    value: pages,
                    checked: checked,
                };
            });
            if (pagesOptions.length > 1) {
                filterList.push({
                    title: t("Pages"),
                    type: "pages",
                    key: "pages",
                    filterFunction: (template, value) => {
                        return template.numUserParts === value;
                    },
                    options: pagesOptions,
                });
            }
        }
        setFilters(filterList);
    }, [templateList, options]);
    return [filters, toggleFilterOption];
};
